// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__Q_cv8","content":"LoadingAlert_content__3lAvZ"};